<template>
    <v-layout justify-center>
        <v-responsive max-width="1140px" width="100%" height="100%" class="px-1">
            <div class="headline text-start mt-8">
                <span>유통데이터 활용 소개</span>
            </div>

            <section class="mt-4">
                <div class="subtitle-2 font-weight-bold">행사 소개</div>

                <v-card class="mt-1">
                    <v-card-text>
                        <v-textarea v-model="festa.section2.txt[0]" outlined hide-details rows="2" />
                    </v-card-text>
                    <v-card-text>
                        <v-textarea v-model="festa.section2.txt[1]" outlined hide-details />
                    </v-card-text>
                </v-card>
            </section>

            <section class="mt-4">
                <div class="subtitle-2 font-weight-bold">데이터를 활용한 새로운 전략 제시</div>

                <v-card class="mt-1">
                    <v-card-text>
                        <v-textarea v-model="festa.section1.txt" outlined hide-details rows="2" />
                    </v-card-text>
                </v-card>
            </section>

            <section class="mt-8">
                <v-layout align-end>
                    <div class="subtitle-2 font-weight-bold">행사 개요</div>
                    <v-spacer/>
                </v-layout>

                <v-card class="mt-2">
                    <v-row :key="index" align="center">
                        <v-col cols="2"></v-col>
                        <v-col></v-col>
                        <v-col cols="auto">
                            <v-btn small color="primary" elevation="4" @click="$set(festa.section3.table.list, festa.section3.table.list.length, {})" class="mr-4"><v-icon left size="16">mdi-plus</v-icon>추가</v-btn>
                        </v-col>
                    </v-row>
                    <v-divider />

                    <v-card-text class="py-0">
                        <template v-for="item, index in festa.section3.table.list">
                            <v-row :key="index" align="center">
                                <v-col cols="2">
                                    <v-textarea v-model="item.title" rows="1" dense outlined hide-details />
                                </v-col>
                                <v-col>
                                    <v-textarea v-model="item.input" rows="1" dense outlined hide-details />
                                </v-col>
                                <v-col cols="auto">
                                    <v-btn small outlined color="red" @click="festa.section3.table.list.splice(index, 1)"><v-icon left size="16">mdi-delete-outline</v-icon>삭제</v-btn>
                                </v-col>
                            </v-row>
                        </template>
                    </v-card-text>
                </v-card>
            </section>

            <section class="mt-4">
                <div class="subtitle-2 font-weight-bold">경진대회 주요 자료</div>

                <v-card class="mt-1">
                    <v-card-text>
                        <v-textarea v-model="festa.section4.txt" outlined hide-details rows="2" />
                    </v-card-text>
                </v-card>
            </section>

            <v-row justify="center" class="mx-1 my-4">
                <v-col md="auto" sm="auto">
                    <v-btn dark color="blue darken-2" elevation="4" @click="save()">저장</v-btn>
                </v-col>
            </v-row>
        </v-responsive>
    </v-layout>
</template>

<script>
import api from "@/api";
export default {
    data() {
        return {

            festa: {
                section1: {
                    txt: null
                },
                section2: {
                    txt: []
                },

                section3: {
                    table: {
                        list: []
                    }
                },

                section4: {
                    txt: null
                },
            },

        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init(){
            let { festa } = await api.console.circulation.festa.get();
            this.festa = festa ?? this.festa;
        },
        log(args){
            console.log({
                args
            });
        },
        async save(){
            await api.console.circulation.festa.put(this.festa);

            alert("저장되었습니다");
        },
        async upload(file, row, col){
            let { src } = await api.resource.post(file, "/res/circulation/festa");
            this.$set(this.festa.section6.contents.frame2302.logoList[row], col, { src, url: "" });
            this.$forceUpdate();
        }
    },
};
</script>
